export default function selectedTabReducer(state = { optionState:""}, action) {
    switch (action.type) {
        case 'SELECTEDTAB_STATE':
            return {
                optionState: action.optionState
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/selectedtabreducer.jsx